
import { tableBody } from './components.mjs';

ACI.UI.tableBody = tableBody;